module.exports = __webpack_public_path__ + "static/media/shanti_stupa_leh.91439dfb.png";